import type { ReactNode } from 'react';

export const symbol_arrow_shape_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-150v-200H167q-14 0-20.5-13t2.5-24l308-384q8.88-11 22.94-11T503-771l308 384q9 11 2.5 24T793-350H640v200q0 12.75-8.62 21.37Q622.75-120 610-120H350q-12.75 0-21.37-8.63Q320-137.25 320-150Zm60-30h200v-200q0-13 8.63-21.5 8.62-8.5 21.37-8.5h103L480-703 247-410h103q12.75 0 21.38 8.62Q380-392.75 380-380v200Zm100-230Z"
		/>
	</svg>
);
